import React from "react";
import Influencers from "../influencers/Influencers";
import HeyGenActors from "../actors/HeyGenActors";
import { TranslateContext } from "../../context/TranslateContext";
import Gallery from "../gallery/Gallery";
import ContentComp from "../content/Content";
import ScriptVideo from "../scripVideo/ScriptVideo";
import Voices from "../voices/Voices";
import UgcAdsWorkflow from "../ugcWorkflow/UgcAdsWorkflow";
import VideoAgent from "../videoAgent/VideoAgent";
import MakeUGC from "../makeugc/MakeUGC";
import MusicStudio from "../music/MusicStudio";
import Support from "../support/Support";
import Usage from "../usage/Usage";
import Notification from "../notification/Notification";
import Logout from "../logout/Logout";
import Dash from "./Dash";
import Billing from "../billing/Billing";
import SocialScheduler from "../socialScheduler/SocialScheduler";
import VideoStudio from "../videoStudio/VideoStudio";
import VideoLibrary from "../videoStudio/VideoLibrary";
import VoiceChanger from "../voiceChanger/VoiceChanger";
import ExploreIdeas from "../exploreIdeas/ExploreIdeas";
import AiClipping from "../aiClipping/AiClipping";
import ResearchChat from "../researchChat/ResearchChat";
import Affiliate from "../affiliate/Affiliate";
class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[PageErrorBoundary] Caught error on page:", this.props.page, error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, color: "#ef4444", fontFamily: "monospace" }}>
          <strong>Page error on "{this.props.page}":</strong>
          <pre style={{ marginTop: 8, whiteSpace: "pre-wrap", fontSize: 13 }}>
            {this.state.error?.message}
            {"\n\n"}
            {this.state.error?.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const Content = ({ selectedMenu, web }) => {
  const { lang } = React.useContext(TranslateContext);

  return (
    <PageErrorBoundary page={selectedMenu}>
      <div>
        {selectedMenu === "dashboards" && <Dash lang={lang} />}
        {selectedMenu === "explore-ideas" && <ExploreIdeas lang={lang} />}
        {selectedMenu === "research-chat" && <ResearchChat lang={lang} />}
        {selectedMenu === "influencers" && <Influencers lang={lang} />}
        {selectedMenu === "actors" && <HeyGenActors lang={lang} />}
        {selectedMenu === "gallery" && <Gallery lang={lang} />}
        {selectedMenu === "content" && <ContentComp lang={lang} />}
        {selectedMenu === "script-to-video" && <ScriptVideo lang={lang} />}
        {selectedMenu === "voices" && <Voices lang={lang} />}
        {selectedMenu === "ugc-ads-workflow" && <UgcAdsWorkflow lang={lang} />}
        {(selectedMenu === "video-agent" || selectedMenu === "b-roll-studio") && (
          <VideoAgent lang={lang} />
        )}
        {selectedMenu === "makeugc" && <MakeUGC lang={lang} />}
        {selectedMenu === "music" && <MusicStudio lang={lang} />}
        {selectedMenu === "video-studio" && <VideoStudio lang={lang} />}
        {selectedMenu === "video-library" && <VideoLibrary lang={lang} />}
        {selectedMenu === "ai-clipping" && <AiClipping lang={lang} />}
        {selectedMenu === "voice-changer" && <VoiceChanger lang={lang} />}
        {selectedMenu === "social-scheduler" && <SocialScheduler lang={lang} />}
        {selectedMenu === "billing" && <Billing lang={lang} />}
        {selectedMenu === "affiliate" && <Affiliate lang={lang} />}
        {selectedMenu === "usage" && <Usage lang={lang} />}
        {selectedMenu === "notification" && <Notification lang={lang} />}
        {selectedMenu === "help" && <Support lang={lang} />}
        {selectedMenu === "logout" && <Logout lang={lang} />}
      </div>
    </PageErrorBoundary>
  );
};

export default Content;
